'use strict'

import {normalize} from "normalizr"

const SET_SEQ_LIST = 'SET_SEQ_LIST'

const SET_SEQ_FILTER = 'SET_SEQ_FILTER'

const SET_SEQ = 'SET_SEQ'
const UPDATE_SEQ = 'UPDATE_SEQ'

import format from 'string-format'
import api from '../../api'
import {Seq} from '../../models'

const initialState = {
	seq_list: [],
	seqs: {},

	seq_filter: {
		name_txt: "",
		sample: -1,
		locus: -1
	},

	seq: Seq.empty_seq,
}

const actions = {
	fetchSeqList: function ({commit, getters, dispatch}) {
		console.debug("store.seq.fetchSeqList()")

		return Promise.all([
			dispatch('seq/list_seq', null, {root: true})
		])
			.then(function ([
				list_seq_promise
			]) {

				console.debug("store.seq.fetchSeqList() then")
			})
	},

	list_seq: function ({commit}) {
		console.debug("store.seq.list_seq() ")

		return api.seq.seq_list()
			.then(function (response) {
				commit(SET_SEQ_LIST, response.data)
				return true
			})
			.catch(function (error) {
				commit(SET_SEQ_LIST, [])
				throw error
			})
	},

	set_filter: function ({commit}, {filter}) {
		commit(SET_SEQ_FILTER, filter)
	},

	fetchSeq: function ({commit, getters, dispatch, rootState}, {seq_id}) {

		if (seq_id) {
			return api.seq.seq_get(seq_id)
				.then(function (response) {
					const seq = new Seq(response.data, rootState)
					commit(SET_SEQ, seq)
				})
				.catch(function (error) {
					commit(SET_SEQ, Seq.empty_seq)
					throw error
				})
		} else {
			commit(SET_SEQ, Seq.empty_seq)
		}
	},
}

const mutations = {
	[SET_SEQ_LIST](state, data) {
		console.debug("store.seq.mutations.SET_SEQ_LIST() ")
		state.seq_list = data
		state.seqs = Object.assign({}, ...data.map((s) => ({[s.id]: s})))
	},

	[SET_SEQ_FILTER](state, data) {
		// переданный объект не надо помещать в store,
		// иначе его потом нельзя менять вне мутаций
		// поэтому скопируем значения свойств
		for (let key in state.seq_filter) {
			state.seq_filter[key] = data[key]
		}
	},

	[SET_SEQ](state, seq) {
		state.seq = seq
	},
}

const getters = {
	seq_list: function (state) {
		return state.seq_list
	},

	seq_filter: function (state) {
		return state.seq_filter
	},

	seq: function (state) {
		return state.seq
	},
}

export default {
	namespaced: true,

	state: initialState,

	actions,
	mutations,
	getters
}

